import { createBrowserHistory } from "history";
import { HistoryManager } from "./lib/history-manager";

HistoryManager.setHistory(createBrowserHistory());

export const history = HistoryManager.getHistory();
